<div class="bg-white rounded-xl border border-gray-200 p-4 hover:shadow-md transition-shadow duration-200">
  <div class="flex flex-row justify-between items-center">
    <div class="flex items-center gap-2 min-w-0">
      <mat-icon style="font-size: 20px; width: 20px; height: 20px; color: #1C593D;">account_balance</mat-icon>
      <span style="font-weight: 700; color: #1e5a3f;" class="truncate">{{ cuenta?.nombre }} {{ cuenta?.apellidos }}</span>
      <span class="text-gray-400 mx-1">-</span>
      <span class="text-sm font-semibold text-gray-700 truncate">Banco {{ cuenta?.banco?.nombre }}</span>
    </div>
    <div style="display: flex; gap: 4px;">
      <button title="Editar" (click)="actualizar()"
        style="display: inline-flex; align-items: center; justify-content: center; width: 30px; height: 30px; border: 1px solid #bfdbfe; border-radius: 6px; background: #eff6ff; cursor: pointer;"
        onmouseover="this.style.background='#dbeafe'" onmouseout="this.style.background='#eff6ff'">
        <mat-icon style="font-size: 16px; width: 16px; height: 16px; color: #2563eb;">edit</mat-icon>
      </button>
      <button title="Eliminar" (click)="inactivarCuenta()"
        style="display: inline-flex; align-items: center; justify-content: center; width: 30px; height: 30px; border: 1px solid #fecaca; border-radius: 6px; background: #fef2f2; cursor: pointer;"
        onmouseover="this.style.background='#fee2e2'" onmouseout="this.style.background='#fef2f2'">
        <mat-icon style="font-size: 16px; width: 16px; height: 16px; color: #dc2626;">delete</mat-icon>
      </button>
    </div>
  </div>
  <div class="grid grid-cols-1 sm:grid-cols-3 gap-2 mt-3">
    <div>
      <span class="text-gray-400 text-xs font-semibold uppercase">Pa&iacute;s</span>
      <p class="text-gray-800 font-medium text-sm mt-0.5">{{ cuenta?.banco?.codigoPais }}</p>
    </div>
    <div>
      <span class="text-gray-400 text-xs font-semibold uppercase">Tipo de cuenta</span>
      <p class="text-gray-800 font-medium text-sm mt-0.5">{{ cuenta?.tipoCuenta?.nombre }}</p>
    </div>
    <div>
      <span class="text-gray-400 text-xs font-semibold uppercase">N&uacute;mero de cuenta</span>
      <p class="text-gray-800 font-mono font-semibold text-sm mt-0.5">{{ cuenta?.numeroCuenta }}</p>
    </div>
  </div>
</div>
